import { Plugin } from "vue";
import * as miscUtils from "./util/miscUtils";
export { miscUtils };
import { default as pcSharedWidgetsVuePlugin } from "./widgets";
export { pcSharedWidgetsVuePlugin };
export const pcSharedComponentsVuePlugin: Plugin = (app) =>
  [pcSharedWidgetsVuePlugin].forEach((p) => app.use(p));
